import { render } from "./ItemEditor.vue?vue&type=template&id=2380b010"
import script from "./ItemEditor.vue?vue&type=script&lang=js"
export * from "./ItemEditor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__